import downArrow from '@SvgIcon/ios-arrow-down.svg'
import rightArrow from '@SvgIcon/ios-arrow-right.svg'

import $ from 'jquery'
import Cookies from 'js-cookie'
import lazySizes from 'lazysizes'
import each from 'lodash/each'
import get from 'lodash/get'
import throttle from 'lodash/throttle'
import { MaskInput } from 'maska'
import moment from 'moment'
import swal from 'sweetalert2'
import Vue from 'vue'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'

import './_mq'
import captchaManager from '../shared/captcha'
import { parseCssDurationToMs } from '../shared/cssUtils'
import { setupA9S } from './_a9s'
import { setupAccordions } from './_accordion'
import { setupAnalyticsCodes } from './_analytics-codes'
import { setupAnimations } from './_anim'
import { setupBlurrables } from './_blurrable'
import { setupCarousels } from './_carousel'
import { isConsentModuleEnabled, setupCookieConsent } from './_cookie-consent'
import { setupCookieConsentCleanup } from './_cookie-consent-cleanup'
import { setupCookieConsentIframes } from './_cookie-consent-iframes'
import { warnOnEmailLinks } from './_email-link'
import { setupInViewObservers } from './_in-view'
import { setupModal } from './_modal'
import { warnOnOutboundLinks } from './_outbound-link'
import { setupParallax } from './_parallax'
import { setupPhotoGalleryObservers } from './_photo-gallery'
import { setupStickyObservers } from './_sticky'
import { setupStickyScrollObservers } from './_sticky-scroll'
import { setupSwipers } from './_swiper'
import { setupTables } from './_table'
import { setupTabs } from './_tabs'
import { setupUploaderFields } from './_uploader-fields'
import { setupVideos } from './_video'
import { setupListNavs } from './component/ListNav'

import './foundation'
import './bootstrap'
import './vue'

import '../shared/address_autocompletion'
import '../shared/component/ProgressCircular'
import '../shared/component/Switch'
import '../shared/widget/char_counter'
import '../shared/widget/password'

import './component/PhotoGallery'
import './component/ProductComparison/setup'
import './component/SocialShare'
import './module/form/handleForms'
import './module/product/productModal'
import './module/search/searchModal'

import '../../scss/app/app.scss'

document.documentElement.setAttribute('data-useragent', navigator.userAgent)

/**
 * iOS 7 has buggy vh unit support. ViewportUnitsBuggyfill takes care of unsupported units in linked stylesheets
 * but can not handle inline <style> elements. We'll detect bad iOS 7 and add a class to handle it manually.
 */

const isBadMobileSafari =
  /(iPhone|iPod|iPad).+AppleWebKit/i.test(window.navigator.userAgent) &&
  (() => {
    const iOSversion = window.navigator.userAgent.match(/OS (\d+)/)
    // viewport units work fine in mobile Safari and webView on iOS 8+
    return iOSversion && iOSversion.length > 1 && parseInt(iOSversion[1]) < 10
  })()

if (isBadMobileSafari) {
  $('html').addClass('no-vh-support')
}

let winUnloaded = false
$(window).on('beforeunload', () => {
  winUnloaded = true
})

$(document).ajaxError((ev, xhr, settings) => {
  if ('errorHandled' in settings && settings.errorHandled) {
    return
  }

  if (winUnloaded || xhr.statusText === 'abort') {
    return
  }

  switch (xhr.status) {
    case 0:
      swal('Error', 'Please check your internet connection.', 'error')
      return
    case 404:
      // No real need for this. Just fail silently.
      // swal('Error', 'The requested page was not found. [404]', 'error');
      return
    case 500:
      swal('Error', 'Internal Server Error. [500]', 'error')
      return
  }

  switch (xhr.statusText) {
    case 'parsererror':
      swal('Error', 'Requested JSON parse failure.', 'error')
      return
    case 'timeout':
      swal('Error', 'Request timed out. Check your internet.', 'error')
      return
    case 'error':
      if ('responseJSON' in xhr && 'error' in xhr.responseJSON) {
        swal('Error', xhr.responseJSON.error, 'error')
      } else {
        swal('Error', xhr.statusText, 'error')
      }
      return
  }
})

const $body = $(document.body)
let mobileNavPreOpenScrollY = null

//
// Vue
//

each(document.querySelectorAll('.vue-mount'), (el) => new Vue({ el }))

//
// Window height for CSS usage
//

function windowHeightForCss() {
  document.documentElement.style.setProperty('--window-height', String(document.documentElement.clientHeight))
}

windowHeightForCss()
$(window).on(
  'resize',
  throttle(() => {
    windowHeightForCss()
  }, 500),
)

//
// Enhance mobile header
//

const $pageHeader = $('.page-header')
const $mobilePageHeader = $('.page-header__mobile')
const $mobilePageHeaderLeft = $mobilePageHeader.find('.left')
const $mobilePageHeaderCenter = $mobilePageHeader.find('.center')
const DEFAULT_HEADER_TRANSITION_DURATION_MS = 150
const MOBILE_NAV_ANCHOR_SCROLL_BUFFER_MS = 20

if (!$mobilePageHeaderLeft.children().length) {
  $mobilePageHeaderLeft.addClass('empty')
  $mobilePageHeaderCenter.addClass('adjust-left')
}

function openMobileNav() {
  mobileNavPreOpenScrollY = window.pageYOffset
  $body.addClass('nav-open')
}

function closeMobileNavWithRestore() {
  $body.removeClass('nav-open')
  if (mobileNavPreOpenScrollY !== null) {
    window.scrollTo({ top: mobileNavPreOpenScrollY, behavior: 'instant' })
    mobileNavPreOpenScrollY = null
  }
}

function closeMobileNavWithoutRestore() {
  $body.removeClass('nav-open')
  mobileNavPreOpenScrollY = null
}

function getHeaderTransitionDelayMs() {
  const pageHeaderEl = $pageHeader.get(0)
  if (!pageHeaderEl) {
    return DEFAULT_HEADER_TRANSITION_DURATION_MS + MOBILE_NAV_ANCHOR_SCROLL_BUFFER_MS
  }

  const transitionDuration = getComputedStyle(pageHeaderEl).getPropertyValue('--header-transition-duration')
  const durationMs = parseCssDurationToMs(transitionDuration)
  const baseDurationMs = durationMs === null ? DEFAULT_HEADER_TRANSITION_DURATION_MS : durationMs
  return baseDurationMs + MOBILE_NAV_ANCHOR_SCROLL_BUFFER_MS
}

$('.js-mobile-nav-toggle').on('click', (ev) => {
  ev.preventDefault()
  if ($body.hasClass('nav-open')) {
    closeMobileNavWithRestore()
    return
  }

  openMobileNav()
})

//
// Hide mobile footer when mobile keyboard appears
// This is a hackish implementation since there isn't a foolproof way to detect the keyboard yet.
//

const originalWinSize = $(window).width() + $(window).height()

function handleMediaQueryChangeKeyboard(mql) {
  const $window = $(window)
  if (mql.matches) {
    $window.off('resize.keyboard-watcher')
  } else {
    $window.on('resize.keyboard-watcher', () => {
      if ($(window).width() + $(window).height() < originalWinSize - 50) {
        $('body').addClass('has-visible-keyboard')
      } else {
        $('body').removeClass('has-visible-keyboard')
      }
    })
  }
}

window.APP.mq.medium.addListener(handleMediaQueryChangeKeyboard)
handleMediaQueryChangeKeyboard(window.APP.mq.medium)

//
// Input masks
//

new MaskInput('[data-maska]')

//
// Date inputs
//

const $dateInputs = $('input[type="date"]')

function handleMediaQueryChangeForDateInputs(mql) {
  if (mql.matches) {
    $dateInputs.attr('type', 'text')
  } else {
    $dateInputs.attr('type', 'date')
  }
}

window.APP.mq.medium.addListener(handleMediaQueryChangeForDateInputs)
handleMediaQueryChangeForDateInputs(window.APP.mq.medium)

//
// "Other" radio/checkbox inputs
//

$(document).on('click', 'input.other-input', (ev) => {
  $(ev.currentTarget).closest('.form-check-label').children(':checkbox, :radio').prop('checked', 'checked')
})

//
// Modal triggers
//

$(document).on('click', 'a[href^="#modal-"]', (ev) => {
  ev.preventDefault()
  // ev.stopImmediatePropagation() // DO NOT UNCOMMENT. Some scripts may rely on this behavior
  const $anchor = $(ev.currentTarget)
  const $modal = $($anchor.attr('href'))
  const modal = setupModal($modal)
  if (modal) {
    modal.open()
  }
})

$(document).on('click', '[data-modal]', (ev) => {
  ev.preventDefault()
  const $trigger = $(ev.currentTarget)
  const $modal = $($trigger.data('modal'))
  const modal = setupModal($modal)
  if (modal) {
    modal.open()
  }
})

if ('automaticModals' in window.APP && Array.isArray(window.APP.automaticModals)) {
  window.APP.automaticModals.forEach((modalId) => {
    const $el = $(`#modal-${modalId}`)
    if (!$el.length) return

    const modal = setupModal($el)
    if (!modal) return

    const oncePerEnabled = $el[0].hasAttribute('data-once-per')
    const oncePerHours = oncePerEnabled ? parseInt($el[0].getAttribute('data-once-per'), 10) : 0
    if (oncePerHours) {
      Cookies.set(`seen_modal_${modalId}`, 1, { expires: oncePerHours / 24 /* days */ })
    }
    modal.open()
  })
}

//
// Hook into anchors to compensate for the fixed header
//

;(function watchAnchors(document, history, location) {
  const HISTORY_SUPPORT = !!(history && history.pushState)

  const anchorScrolls = {
    ANCHOR_REGEX: /^#(?!modal-|accordion-panel-|tab-|ns-)[^ ]+$/,

    normalizePathname(pathname) {
      if (!pathname) {
        return '/'
      }
      return pathname.replace(/\/+$/, '') || '/'
    },

    parseAnchorHref(href) {
      if (!href) {
        return null
      }

      if (this.ANCHOR_REGEX.test(href)) {
        return {
          hash: href,
          pathname: this.normalizePathname(location.pathname),
          search: location.search,
        }
      }

      let parsedUrl
      try {
        parsedUrl = new URL(href, location.href)
      } catch (e) {
        return null
      }

      if (!this.ANCHOR_REGEX.test(parsedUrl.hash)) {
        return null
      }

      return {
        hash: parsedUrl.hash,
        pathname: this.normalizePathname(parsedUrl.pathname),
        search: parsedUrl.search,
      }
    },

    isMobileNavSamePageAnchorClick(anchor, parsedAnchor) {
      if (!$body.hasClass('nav-open')) {
        return false
      }

      if (!anchor.closest('.mobile-nav')) {
        return false
      }

      return (
        this.normalizePathname(location.pathname) === parsedAnchor.pathname && location.search === parsedAnchor.search
      )
    },

    /**
     * Establish events, and fix initial scroll position if a hash is provided.
     */
    init() {
      setTimeout(() => {
        this.scrollToCurrent()
      }, 100)
      window.addEventListener('hashchange', this.scrollToCurrent.bind(this))
      document.body.addEventListener('click', this.delegateAnchors.bind(this))
    },

    /**
     * Return the offset amount to deduct from the normal scroll position.
     * Modify as appropriate to allow for dynamic calculations
     */
    getFixedOffset() {
      let offset = $('.page-header').height() + 50

      // Add additional offset from CSS custom property if defined
      const additionalOffset = getComputedStyle(document.documentElement)
        .getPropertyValue('--additional-anchor-scroll-offset')
        .trim()

      if (additionalOffset) {
        const additionalValue = parseFloat(additionalOffset)
        if (!Number.isNaN(additionalValue)) {
          offset += additionalValue
        }
      }

      return offset
    },

    /**
     * If the provided href is an anchor which resolves to an element on the
     * page, scroll to it.
     * @param  {String} href
     * @param  {Boolean} pushToHistory
     * @return {Boolean} - Was the href an anchor.
     */
    scrollIfAnchor(href, pushToHistory) {
      if (!this.ANCHOR_REGEX.test(href)) {
        return false
      }

      const match = document.getElementById(href.slice(1))

      if (match) {
        const rect = match.getBoundingClientRect()
        const anchorOffset = window.pageYOffset + rect.top - this.getFixedOffset()
        window.scrollTo(window.pageXOffset, anchorOffset)

        // Add the state to history as-per normal anchor links
        if (HISTORY_SUPPORT && pushToHistory) {
          history.pushState({}, document.title, location.pathname + href)
        }
      }

      return !!match
    },

    /**
     * Attempt to scroll to the current location's hash.
     */
    scrollToCurrent() {
      this.scrollIfAnchor(window.location.hash, false)
    },

    /**
     * If the click event's target was an anchor, fix the scroll position.
     */
    delegateAnchors(ev) {
      const anchor = ev.target.closest('a')
      if (anchor) {
        const href = anchor.getAttribute('href')
        const parsedAnchor = this.parseAnchorHref(href)

        if (parsedAnchor && this.isMobileNavSamePageAnchorClick(anchor, parsedAnchor)) {
          ev.preventDefault()
          closeMobileNavWithoutRestore()
          setTimeout(() => {
            this.scrollIfAnchor(parsedAnchor.hash, true)
          }, getHeaderTransitionDelayMs())
          return
        }

        if (!$(anchor).data() || Object.keys($(anchor).data()).length === 0) {
          if (parsedAnchor && this.ANCHOR_REGEX.test(parsedAnchor.hash)) {
            ev.preventDefault()
            this.scrollIfAnchor(parsedAnchor.hash, true)
          }
        }
      }
    },
  }

  const init = () => {
    anchorScrolls.init.bind(anchorScrolls)()
  }

  if (module.hot) {
    $(window).on('load', init)
  } else {
    $(document).ready(init)
  }
})(window.document, window.history, window.location)

//
// Custom reveal
//

$('.custom.reveal').on('click', '.overlay', (ev) => {
  $(ev.currentTarget).closest('.reveal').foundation('close')
})

//
// Videos
//

setupVideos(document.body)

//
// A9s
//

setupA9S(document.body)

//
// Accordions
//

setupAccordions(document.body)

//
// Blurrable BG
//

setupBlurrables(document.body)

//
// Captchas
//

captchaManager.initialize().then(() => {
  captchaManager.watchForElements(document.body)
  captchaManager.setupForms(document.body)
})

//
// Tables
//

setupTables(document.body)

//
// Tabs
//

setupTabs(document.body)

//
// Uploader fields
//

setupUploaderFields(document.body)

//
// Carousels
//

setupCarousels(document.body)

//
// In-View Observers
//

setupInViewObservers(document.body)

//
// List Navs
//

setupListNavs(document.body)

//
// Photo Galleries
//

setupPhotoGalleryObservers(document.body)

//
// Parallax
//

setupParallax(document.body)

//
// Sticky Observers
//

setupStickyObservers(document.body)
setupStickyScrollObservers(document.body)

//
// Swipers
//

setupSwipers(document.body)

//
// Outbound links
//

if (get(window, ['APP', 'context', 'outbound_link_warning', 'display'], false)) {
  warnOnOutboundLinks()
}

//
// Email links
//

if (get(window, ['APP', 'context', 'email_link_warning', 'display'], false)) {
  warnOnEmailLinks()
}

//
// Header resize
//

const SMALL_HEADER_THRESHOLD = 300

function resizeHeader() {
  if (window.scrollY > SMALL_HEADER_THRESHOLD) {
    $pageHeader.addClass('smaller')
    $body.addClass('smaller-header')
  } else {
    $pageHeader.removeClass('smaller')
    $body.removeClass('smaller-header')
  }
}

resizeHeader()
$(window).on('scroll', throttle(resizeHeader, 100))

//
// Lazy loading
//

if (module.hot) {
  $(window).on('load', () => {
    lazySizes.init()
  })
} else {
  lazySizes.init()
}

//
// Announcement
//

const CLOSEABLE_COOKIE_ID = 'closeables'

function getClosedCloseables() {
  const cookieVal = Cookies.get(CLOSEABLE_COOKIE_ID)
  if (!cookieVal) {
    return []
  }
  const closed = cookieVal.split(',')
  if (!Array.isArray(closed)) {
    return []
  }
  return closed
}

function addClosedCloseable(closeableId) {
  const closedCloseables = getClosedCloseables()
  closedCloseables.push(closeableId)
  Cookies.set(CLOSEABLE_COOKIE_ID, closedCloseables.join(','), { expires: 1 / 24 /* 1 hour */ })
}

$('.announcement-wrap').each((idx, el) => {
  const $container = $(el)
  const closeableId = el.getAttribute('data-closeable-id')
  if (!el.hasAttribute('data-is-preview')) {
    const closedCloseables = getClosedCloseables()
    if (closeableId && closedCloseables.indexOf(closeableId) !== -1) {
      $container.hide()
      return
    }
  }
  $container.on('click', '[data-close]', () => {
    $container.slideUp()
    if (closeableId) {
      addClosedCloseable(closeableId)
    }
  })
})

//
// Event announcement
//

function refreshCountdown(targetEl, duration) {
  const textParts = []
  if (duration.asHours() > 0) {
    textParts.push(`${Math.floor(duration.asHours())}h`)
  }
  textParts.push(`${duration.minutes()}m`)
  textParts.push(`${duration.seconds()}s`)
  targetEl.innerHTML = textParts.join(' ')
}

const eventAnnouncement = document.querySelector('.announcement-wrap.is-event')
if (eventAnnouncement) {
  const eventCountdownEl = eventAnnouncement.querySelector('.countdown')
  if (eventCountdownEl) {
    const eventLiveStartString = eventCountdownEl.getAttribute('data-live-start')
    const eventLiveEndString = eventCountdownEl.getAttribute('data-live-end')
    const eventLiveStartDate = moment(eventLiveStartString)
    const eventLiveEndDate = moment(eventLiveEndString)
    let eventLiveStartDur = moment.duration(eventLiveStartDate.diff(moment()))
    let eventLiveEndDur = moment.duration(eventLiveEndDate.diff(moment()))
    let eventLiveEnded = false

    // Keep track of when LIVE ends and remove the LIVE message.
    const eventLiveEndTimer = setInterval(() => {
      if (eventLiveEndDur.asMilliseconds() <= 2000) {
        eventLiveEnded = true
        clearInterval(eventLiveEndTimer)
        eventCountdownEl.innerHTML = ''
        return
      }
      eventLiveEndDur = eventLiveEndDur.subtract(1, 'second')
    }, 1000)

    const eventLiveCountdownTimer = setInterval(() => {
      if (eventLiveStartDur.asMilliseconds() <= 2000) {
        clearInterval(eventLiveCountdownTimer)
        if (!eventLiveEnded) {
          eventCountdownEl.innerHTML = '<span class="live">Live – Join Now!</span>'
        }
        return
      }
      eventLiveStartDur = eventLiveStartDur.subtract(1, 'second')
      refreshCountdown(eventCountdownEl, eventLiveStartDur)
    }, 1000)
  }
}

//
// Animations
//

setupAnimations(document.body)

//
// Cookie consent
//

setupAnalyticsCodes()
setupCookieConsentCleanup()
setupCookieConsentIframes()
if (isConsentModuleEnabled()) {
  setupCookieConsent()
}
